import InfoIcon from "assets/icons/info.svg?react";

import { Popover } from "shared/ui/components/Popover";
import { Typography } from "shared/ui/components/Typography";

import styles from "./InfoCard.module.scss";

const InfoCard = ({
  text,
  amount,
  infoPopover,
}: {
  text: string;
  amount: string;
  infoPopover?: React.ReactNode;
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Typography variant="h4" weight="semiBold" className={styles.amount}>
          {amount}
        </Typography>
        {!!infoPopover && (
          <Popover
            placement="top"
            triggerType="hover"
            yOffset={15}
            floatingArrowProps={{ width: 17, height: 10, fill: "#fff" }}
            triggerClassName={styles.trigger}
            triggerElement={() => <InfoIcon className={styles.infoIcon} />}
          >
            {infoPopover}
          </Popover>
        )}
      </div>
      <div className={styles.infoCardContent}>
        <Typography variant="bodyM" className={styles.text}>
          {text}
        </Typography>
      </div>
    </div>
  );
};

export default InfoCard;
